// import TweenLite from './vendor/TweenLite';
// import { qs, qsArray } from './utilities/selectors';
import {qs, qsArray, isInternetExplorer, isEdge, trackEvent} from './utilities/index';
import Application from "./application";

let Slider = function (params) {
  // console.log('Slider initalizing ' + params);

  /**
   *
   */
  let self = this;
  let sliderElement = document.getElementById(params.elementId);
  let mobileCircleElement = document.getElementById(params.mobileCircleId);
  let input = sliderElement.querySelector('input[type="range"]');
  let startLabel = sliderElement.querySelector('.start-label');
  let middleLabel = sliderElement.querySelector('.middle-label');
  let endLabel = sliderElement.querySelector('.end-label');
  let closeButton = document.getElementById('close-button');

  this.initialize = function () {
    input = sliderElement.querySelector('input[type="range"]');
    if ( input !== null ) {
      if (isInternetExplorer() === true) {
        // chrome slider released, works in ie
        input.addEventListener('change', this.sliderChanged);
      } else {
        // chrome slider moved, doesn't work in ie works in edge and everything else
        input.addEventListener('input', this.sliderChanged);
      }

      if (sliderElement.id === 'q3-slider') {
        input.addEventListener('mouseover', this.sliderOver);
        input.addEventListener('mouseout', this.sliderOut);
      }
    }
    // console.log('mobileCircleId is ' + params.mobileCircleId);
    // console.log('mobileCircleElement is ', mobileCircleElement);
    mobileCircleElement.addEventListener('click', this.mobileCircleClicked);
    closeButton.addEventListener('click', this.closeButtonClicked);
  };

  this.sliderOver = function (event) {
    console.log('over');
    let input = event.target;
    console.log('over value is : ', input.value);
    if (input.value === '2' || input.value === '3') {
      document.getElementById('clubheads').classList.add('selected');
    }
  };

  this.sliderOut = function (event) {
    console.log('out');
    document.getElementById('clubheads').classList.remove('selected');
  };

  this.sliderChanged = function (event) {
    // console.log('changed: ', event);
    let input = event.target;
    console.log('value is : ', input.value);
    console.log('sliderElement is ' + sliderElement.id);
    if ( sliderElement.id === 'q1-slider') {
      let display = input.value;
      // if (display <= 200) {
      //   display = "200";
      // } else if (display >= 300) {
      //   display = "300";
      // }
      let units = sliderElement.getAttribute('data-units');
      if (units === null || units === undefined || units === "") {
        units = 'YDS';
      }
      let min = sliderElement.getAttribute('data-min');
      if (min === null || min === undefined) {
        min = '';
      }
      let max = sliderElement.getAttribute('data-max');
      if (max === null || max === undefined) {
        max = '';
      }
      if (display === "200") {
        display = min;
      } else if (display === "300") {
        display = max;
      } else {
        display = display.toString() + ' ' + units;
        // let offset = parseInt(sliderElement.getAttribute('data-offset'), 10);
        // let distance = parseInt(input.value, 10);
        // distance = distance - offset;
        // display = distance.toString() + ' ' + units;
      }

      // offset for locales

      middleLabel.innerHTML = display.toString();
    } else {
      self.resetLabels();
      if (input.value === '1') {
        startLabel.classList.add('selected');
      } else if (input.value === '2') {
        middleLabel.classList.add('selected');
      } else if (input.value === '3') {
        endLabel.classList.add('selected');
      }
    }
    if (sliderElement.id == 'q3-slider') {
      window.driverSelector.questions.setClubhead();
    } else {
      window.driverSelector.questions.setPath();
      window.driverSelector.questions.setLandingSpot();
    }
  };

  this.mobileCircleClicked = function (event) {
    // console.log('mobileCircleClicked');
    window.driverSelector.questions.closeAllSliders();
    document.getElementById('sliders').classList.add('selected');
    document.getElementById('sliders').classList.add(params.mobileCircleId);
    sliderElement.classList.add('selected');
    mobileCircleElement.classList.add('selected');
    document.getElementById('clubheads').classList.remove('selected');

  };

  this.closeButtonClicked = function (event) {
    // console.log('closeButtonClicked');
    window.driverSelector.questions.closeAllSliders();

  };

  this.closeMobileSlider = function() {
    // console.log('closeMobileSlider');
    document.getElementById('sliders').classList.remove('selected');
    document.getElementById('sliders').classList.remove(params.mobileCircleId);
    sliderElement.classList.remove('selected');
    mobileCircleElement.classList.remove('selected');
    document.getElementById('clubheads').classList.remove('selected');
  };

  this.getFlight = function() {
    let flightSlider = document.getElementById('q2-slider');
    let value = flightSlider.querySelector('input[type="range"]').value;
    let flight = 'low';
    if (value === '1') {
      flight = 'low';
    } else if (value === '2') {
      flight = 'medium';
    } else if (value === '3') {
      flight = 'high';
    }
    return flight;
  };

  this.getDistance = function() {
    let flightSlider = document.getElementById('q1-slider');
    let value = flightSlider.querySelector('input[type="range"]').value;
    return value;
  };

  this.getValue = function() {
    return input.value;
  };

  this.resetLabels = function () {
    startLabel.classList.remove('selected');
    middleLabel.classList.remove('selected');
    endLabel.classList.remove('selected');
  }
};

export default Slider;

